import script from "./SupportModalContent.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportModalContent.vue?vue&type=script&setup=true&lang=js"

import "./SupportModalContent.vue?vue&type=style&index=0&id=c9d1d384&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9d1d384"]])

export default __exports__